import { DocumentPreviewModeSwitch } from './DocumentPreviewModeSwitch'
import { DocumentTabs } from './DocumentTabs'
import {
  TabsWrapper,
  Toolbar,
  ToolbarAgentButtonSlot,
} from './documentTabsStyles'

export function DocumentTabsBar() {
  return (
    <Toolbar>
      <TabsWrapper>
        <DocumentTabs />
      </TabsWrapper>
      <ToolbarAgentButtonSlot>
        <DocumentPreviewModeSwitch />
      </ToolbarAgentButtonSlot>
    </Toolbar>
  )
}
